export const ChannelEntryRecipie = {
    $type$: 'Recipe',
    name: 'LinkedListEntry',
    rule: [
        {
            itemprop: 'data',
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['CreationTime']) }
        },
        {
            itemprop: 'metadata',
            itemtype: {
                type: 'bag',
                item: { type: 'referenceToObj', allowedTypes: new Set(['*']) }
            },
            optional: true
        },
        {
            itemprop: 'previous',
            optional: true,
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['LinkedListEntry']) }
        }
    ]
};
export const ChannelInfoRecipe = {
    $type$: 'Recipe',
    name: 'ChannelInfo',
    crdtConfig: new Map([['head#referenceToObj', 'LinkedListCrdtAlgorithm']]),
    rule: [
        {
            itemprop: 'participants',
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['HashGroup']) },
            isId: true
        },
        {
            itemprop: 'discriminator',
            itemtype: { type: 'string' },
            isId: true,
            optional: true
        },
        {
            itemprop: 'owner',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Person']) },
            isId: true,
            optional: true
        },
        {
            itemprop: 'head',
            optional: true,
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['LinkedListEntry']) }
        },
        {
            // ABAC: Minimum trust level required to access channel content
            itemprop: 'demandsTrustLevel',
            optional: true,
            itemtype: { type: 'string' }
        }
    ]
};
export const ChannelRegistryRecipe = {
    $type$: 'Recipe',
    name: 'ChannelRegistry',
    rule: [
        {
            itemprop: 'id',
            itemtype: { type: 'string', regexp: /^ChannelRegistry$/ },
            isId: true
        },
        {
            itemprop: 'channels',
            itemtype: {
                type: 'set',
                item: {
                    type: 'referenceToId',
                    allowedTypes: new Set(['ChannelInfo'])
                }
            }
        }
    ]
};
const ChannelRecipes = [ChannelEntryRecipie, ChannelInfoRecipe, ChannelRegistryRecipe];
// #### Reverse maps ####
// Track which ChannelInfo objects reference each HashGroup via their 'participants' property.
// This enables determineAccessibleHashes to find channels for a person based on HashGroup membership.
export const ChannelInfoReverseMaps = [
    ['ChannelInfo', new Set(['participants'])]
];
export default ChannelRecipes;
//# sourceMappingURL=ChannelRecipes.js.map